import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/static/icons/checkmark_icon.svg'


const _hoisted_1 = {
  key: 0,
  class: "quantity-selector-row-dropdown__stock-checkmark",
  src: _imports_0,
  alt: "selected option checkmark"
}

import { computed, ref } from 'vue';
import ConfiguratorChevron from '../ConfiguratorChevron.vue';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuantitySelectorRowDropdown',
  props: {
  stockData: {
    type: Object,
    required: true
  },
  quantity: {
    type: Number,
    default: 0
  },
  isGiftCard: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props;

const options = computed(() =>
  props.stockData.filter((s) => s.type === 'option')
);

const { websiteText } = useWebsiteTexts();

const selectedStock = computed(() => {
  let total = 0;
  if (props.isGiftCard) {
    return {
      text: `${websiteText('productdetailspage_always_in_stock').value}`,
      icon: 'available'
    };
  }
  return (
    options.value.find((s) => {
      total += s.quantity;
      return props.quantity <= total;
    }) || options.value[0]
  );
});

const canOpenDropdown = computed(() => options.value.length > 1);

const dropdownOpen = ref(false);

function toggleDropdown() {
  dropdownOpen.value = !dropdownOpen.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'quantity-selector-row-dropdown__stock',
      { 'quantity-selector-row-dropdown__stock--dropdown': canOpenDropdown.value },
      `quantity-selector-row-dropdown__stock-option--${selectedStock.value?.icon}`
    ]),
    onClick: toggleDropdown
  }, [
    _createTextVNode(_toDisplayString(selectedStock.value.text) + " ", 1),
    (canOpenDropdown.value)
      ? (_openBlock(), _createBlock(ConfiguratorChevron, {
          key: 0,
          class: "quantity-selector-row-dropdown__stock-chevron",
          open: dropdownOpen.value
        }, null, 8, ["open"]))
      : _createCommentVNode("", true),
    (canOpenDropdown.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
        'quantity-selector-row-dropdown__stock-options',
        { 'quantity-selector-row-dropdown__stock-options--open': dropdownOpen.value }
      ])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stockData, (stock) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([
          'quantity-selector-row-dropdown__stock-option',
          `quantity-selector-row-dropdown__stock-option--${stock.icon}`,
          {
            'quantity-selector-row-dropdown__stock-option--selected':
              stock.id === selectedStock.value?.id &&
              stock.text === selectedStock.value?.text
          },
          {
            'quantity-selector-row-dropdown__headline': stock.type == 'headline'
          }
        ]),
              key: stock.id
            }, [
              _createTextVNode(_toDisplayString(stock.text) + " ", 1),
              (
            stock.id === selectedStock.value?.id && stock.text === selectedStock.value?.text
          )
                ? (_openBlock(), _createElementBlock("img", _hoisted_1))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})